import React from 'react'
import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import CustomModal from 'components/commons/CustomModal'
import ErrorIcon from '@material-ui/icons/Error'
import questionnaireStyles from '../CreateQuestionnaire/styles'
import { useHistory } from 'react-router-dom'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'

const useStyles = makeStyles(theme => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3)
   }
}))

function ConfirmationModalDeleteQuestion({
   indexData,
   actionSubmit,
   showComfirmationModal,
   setShowComfirmationModal,
   message = 'Señor usuario, ¿Está seguro que desea eliminar la pregunta con todos los datos?'
}) {
   const classesModal = useStyles()
   const classes = questionnaireStyles()

   const onSubmitModal = () => {
      setShowComfirmationModal(false)
      actionSubmit(indexData?.index)
   }
   return (
      <Modal
         open={showComfirmationModal}
         className={classesModal.modal}
         aria-labelledby="spring-modal-title"
         aria-describedby="spring-modal-description"
         onClose={() => setShowComfirmationModal(false)}
         on
         BackdropComponent={Backdrop}
         closeAfterTransition
         BackdropProps={{
            timeout: 500
         }}
      >
         <div className={classesModal.paper}>
            <Grid className={classes.confirmModalContainer}>
               <div style={{ alignSelf: 'center', marginBottom: 16 }}>
                  <ErrorIcon style={{ color: '#F0A71E', fontSize: 68 }} />
               </div>
               <Typography
                  style={{
                     marginBottom: 16,
                     width: '60%',
                     alignSelf: 'center',
                     textAlign: 'center'
                  }}
               >
                  {message}
               </Typography>
               <div className={classes.modalButtonsContainer}>
                  <Button
                     style={{ margin: '0 10px 0 10px' }}
                     variant="contained"
                     disableElevation
                     color="primary"
                     onClick={() => onSubmitModal()}
                  >
                     Sí
                  </Button>
                  <Button
                     style={{ margin: '0 10px 0 10px' }}
                     variant="outlined"
                     disableElevation
                     color="primary"
                     onClick={() => setShowComfirmationModal(false)}
                  >
                     No
                  </Button>
               </div>
            </Grid>
         </div>
      </Modal>
   )
}

export default ConfirmationModalDeleteQuestion
